import { shallowEqual } from "react-redux";
import { useAppSelector } from "../../state/store-hooks";

const useGetLabelVariant = () => {
     const {
       showValidationBelowFields,
       inputLabelVariant,
       layout
     } = useAppSelector(
       (state: any) => ({
         showValidationBelowFields: state.initTheme?.theme_editor_settings?.customization_settings?.show_validation_below_fields,
         inputLabelVariant: state.initTheme?.theme_editor_settings?.customization_settings?.input_field_style,
         layout: state.initTheme?.theme_editor_settings?.customization_settings?.layout
       }),
       shallowEqual
     ); 

    const isAmountFirst = layout === 'amount-first';

    const getInputLabelVariant = () => {
        if (!showValidationBelowFields || isAmountFirst) return inputLabelVariant;

        switch(inputLabelVariant) {
            case 'no_label':
                return 'separate_fields';
            default:
                return inputLabelVariant;
        }
    }

    return {
        getInputLabelVariant
    }
}

export default useGetLabelVariant;